











































































































































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import InterestRateType from '@/models/Products/InterestRateType';
import PostingScheduleType from "@/models/Shared/PostingScheduleType";
import ProductSubType from "@/models/Products/ProductSubType";
import PeriodType from '@/models/Shared/PeriodType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'SecondaryWalletsEditInterestSettingsDialog' })
export default class extends SaascadaVueDialog {

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;
    valid = true;
    dialog = false;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            ProductDetailsModule.prepareSecondaryWalletTypeViewModel();
            await ProductDetailsModule.getRateSources();
        }
    }

    get currentSecondaryWallet() {
        return ProductDetailsModule.currentSecondaryWalletTypeViewModel;
    }

    get rateSourceOptions() {
        return ProductDetailsModule.rateSources;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get interestCalculatedOnOptions() {
        return ListUtils.interestCalculatedOnOptions();
    }

    get interestPostedTypeOptions() {
        return ListUtils.interestPostedTypeOptions();
    }

    get postingScheduleTypeOptions() {
        if (ProductDetailsModule.product.generalSettings.subType === ProductSubType.DepositFixedTerm) {
            return ListUtils.postingScheduleTypeOptionsForFixedTerm();
        }
        else {
            return ListUtils.postingScheduleTypeOptions();
        }
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get nonWorkingDaysOptions() {
        return ListUtils.nonWorkingDaysOptions();
    }

    get dayOfWeekOptions() {
        return ListUtils.dayOfWeekOptions();
    }

    get dayOfMonthOptions() {
        return ListUtils.dayOfMonthOptions();
    }

    get monthOptions() {
        return ListUtils.monthOptions();
    }

    get daysInYearOptions() {
        return ListUtils.interestDaysInYearOptions();
    }

    get baseRateOptions() {
        return ListUtils.interestBaseRateOptions();
    }

    get isFixedSchedule() {
        return this.currentSecondaryWallet.depositInterestSettings.postingScheduleType === PostingScheduleType.FixedSchedule;
    }

    async save() {
        if (!this.valid) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editSecondaryWalletTypeInterestSettings();
        }
    }

}
